import(/* webpackMode: "eager" */ "/home/bas/app_e1e219a2-5e21-4445-a439-6505c6bf5f4d/frontend/src/app/[locale]/error.tsx");
